import 'regenerator-runtime';

import { LoginType, MsalAuthProvider } from 'react-aad-msal';

import { getEnv } from '../config';

export const AzureAuthProvider = new MsalAuthProvider(
    {
        auth: {
            authority: `https://login.microsoftonline.com/${getEnv('REACT_APP_AZURE_TENANT_ID')}`,
            clientId: getEnv('REACT_APP_AZURE_CLIENT_ID'),
            postLogoutRedirectUri: window.location.origin,
            redirectUri: window.location.origin,
            validateAuthority: true,
            navigateToLoginRequestUrl: true,
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: true,
        },
    },
    {
        scopes: ['openid'],
    },
    {
        loginType: LoginType.Redirect,
    },
);
